import{HLS_HANDLER_ID as r}from"../constants";export var isHlsHandler=function(t){return t.getId()===r};